import axios from "axios";
import { getSessionId } from "../utils/session";

let currentToken: string | null = null;
let currentUserId: string = "anonymous";

const client = axios.create({
  baseURL: process.env.REACT_APP_GATEWAY_URL || "http://localhost:4000",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to set token from Auth context
export const setClientToken = (token: string | null) => {
  currentToken = token;
};

// Function to set user ID from Auth context
export const setClientUserId = (userId: string | null) => {
  currentUserId = userId || "anonymous";
};

// Request interceptor to add auth token

client.interceptors.request.use(
  (config) => {
    // The access token is held in memory (set by AuthContext) and the refresh
    // token in an httpOnly cookie — deliberately never in localStorage, which is
    // readable by any injected script (XSS token theft).
    const token = currentToken;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers['x-user-id'] = 'user_' + currentUserId
    // Set here as well as in the fetch wrapper (utils/session.ts): axios uses
    // XMLHttpRequest in the browser, not fetch, so the wrapper never sees these
    // calls. Every request from this client is gateway-bound by construction —
    // it has the gateway as its baseURL.
    config.headers['X-Session-ID'] = getSessionId()
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor - handle auth errors globally

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access - e.g., redirect to login
      console.warn("Unauthorized access - redirecting to login");
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

export default client;